import axios from '../axios'
// 获取列表
export const getHonoraryList = (data) => {
  return axios({
    url: '/honorQualification/list',
    method: 'GET',
    data
  })
}
// 修改
export const editHonorary = (data) => {
  return axios({
    url: '/honorQualification/edit',
    method: 'POST',
    data
  })
}
// 添加
export const addHonorary = (data) => {
  return axios({
    url: '/honorQualification/create',
    method: 'POST',
    data
  })
}
// 上架
export const honoraryStatus = (data) => {
  return axios({
    url: '/honorQualification/updateStatus',
    method: 'POST',
    data
  })
}
// 删除
export const removeHonorary = (data) => {
  return axios({
    url: '/honorQualification/remove',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/honoraryManage.js